export default __webpack_public_path__ + "static/media/acting_as_mediator.a9e5a133.svg";